import React, { useState, useEffect } from 'react';
import './UserPagesOptimized.css';
import { useNavigate } from 'react-router-dom';
import './UserPagesOptimized.css';
import { favoriteAPI } from '../../services/api';
import './UserPagesOptimized.css';

interface Favorite {
  id: number;
  course_id: number;
  course_name: string;
  teacher_name: string;
  price: number;
  location: string;
  start_date: string;
  image_url: string;
}

const FavoritesPage: React.FC = () => {
  const [favorites, setFavorites] = useState<Favorite[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const data = await favoriteAPI.getMyFavorites();
      setFavorites(data);
    } catch (error) {
      console.error('获取收藏失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const removeFavorite = async (courseId: number) => {
    try {
      await favoriteAPI.removeFavorite(courseId);
      setFavorites(prev => prev.filter(fav => fav.course_id !== courseId));
    } catch (error) {
      console.error('取消收藏失败:', error);
      alert('取消收藏失败');
    }
  };

  const handleCourseClick = (courseId: number) => {
    navigate(`/courses/${courseId}`);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  if (loading) return <div className="loading">加载中...</div>;

  return (
    <div className="favorites-page">
      <div className="favorites-header">
        <h2>我的收藏</h2>
      </div>

      <div className="favorites-list">
        {favorites.length === 0 ? (
          <div className="empty-state">
            <p>暂无收藏课程</p>
            <button className="browse-btn" onClick={() => navigate('/courses')}>
              去浏览课程
            </button>
          </div>
        ) : (
          favorites.map(favorite => (
            <div key={favorite.id} className="favorite-item">
              <div className="course-image">
                <img 
                  src={favorite.image_url || "https://via.placeholder.com/150"} 
                  alt={favorite.course_name}
                  onClick={() => handleCourseClick(favorite.course_id)}
                />
              </div>
              
              <div className="course-info">
                <h3 onClick={() => handleCourseClick(favorite.course_id)}>
                  {favorite.course_name}
                </h3>
                <p className="teacher">老师: {favorite.teacher_name}</p>
                <p className="location">地点: {favorite.location}</p>
                <p className="time">开课时间: {formatDate(favorite.start_date)}</p>
                <p className="price">价格: ¥{favorite.price}</p>
              </div>

              <div className="actions">
                <button 
                  className="remove-btn" 
                  onClick={() => removeFavorite(favorite.course_id)}
                >
                  取消收藏
                </button>
                <button 
                  className="register-btn" 
                  onClick={() => navigate(`/courses/${favorite.course_id}`)}
                >
                  立即报名
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;